import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Tabs, Empty } from "@/components/kit";
import { Icon } from "@/components/Icon";
import { CATEGORIES, ICONS } from "@/data/customItems";

export default function CustomItems() {
  const [cat, setCat] = useState("habit");
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [icon, setIcon] = useState("heart");
  const meta = CATEGORIES.find((c) => c.id === cat);

  const load = () => api.get(`/items?category=${cat}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, [cat]); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try { await api.post("/items", { name: name.trim(), category: cat, icon, color: meta.color }); setName(""); toast.success("Item added"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (id) => { await api.delete(`/items/${id}`); load(); };

  return (
    <div className="max-w-3xl" data-testid="custom-items-page">
      <PageHeader back title="Customize Tracking" subtitle="Your own habits, symptoms, triggers and wellness items" />
      <Tabs items={CATEGORIES.map((c) => ({ id: c.id, name: c.name }))} value={cat} onChange={setCat} testPrefix="custom-items-cat" />
      <form onSubmit={add} className="mm-card p-5">
        <div className="flex gap-2">
          <input className="mm-input" placeholder={`New ${meta.name.toLowerCase().replace(/s$/, "")}…`} value={name} onChange={(e) => setName(e.target.value)} data-testid="custom-item-name-input" />
          <button className="mm-btn" data-testid="custom-item-add-button"><Plus size={16} />Add</button>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-4">
          {ICONS.map((i) => (
            <button type="button" key={i} onClick={() => setIcon(i)} data-testid={`custom-item-icon-${i}`} className={`p-2 rounded-xl transition-colors ${icon === i ? "text-white" : "mm-soft"}`} style={icon === i ? { background: meta.color } : {}}>
              <Icon name={i} size={18} />
            </button>
          ))}
        </div>
      </form>
      <div className="grid sm:grid-cols-2 gap-3 mt-6">
        {items.map((it) => (
          <div key={it.id} className="mm-card p-4 flex items-center gap-3" data-testid={`custom-item-${it.id}`}>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${it.color || meta.color}22`, color: it.color || meta.color }}>
              {it.icon && /^[a-z-]+$/.test(it.icon) ? <Icon name={it.icon} size={18} /> : <span className="text-lg">{it.icon || "✨"}</span>}
            </div>
            <span className="flex-1 font-medium">{it.name}</span>
            <button onClick={() => remove(it.id)} className="text-mm-muted hover:text-mm-error" data-testid={`custom-item-delete-${it.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
      {!items.length && <div className="mt-6"><Empty emoji="✨" title={`No ${meta.name.toLowerCase()} yet`} text="Add your first one above." /></div>}
    </div>
  );
}
